//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MiniNavBar from '@/components/MiniNavBar.vue';

export default {
    components: { MiniNavBar },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.getTypes();
            vm.getSpecialFood();
            vm.getHotelList();
            vm.getRestList();
            vm.getSpecialty();
        });
    },
    data() {
        return {
            currentItem: 0,
            typeList: [],
            specialFood: '',
            hotelList: [],
            restList: [],
            specialList: [],
            specialFoodList: [],
            banner: ''
        };
    },
    computed: {
        transX() {
            return this.currentItem * -100 + '%';
        }
    },
    methods: {
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 4
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getHotelList() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '46',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.hotelList = res.data.data;
                }
            });
        },
        getHotelDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.hotelDetail = res.data;
                    this.show.hotelDetail = true;
                }
            });
        },
        getRestList() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '47',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.restList = res.data.data;
                }
            });
        },
        getRestDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.restDetail = res.data;
                    this.show.restDetail = true;
                }
            });
        },
        getSpecialty() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '48',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.specialList = res.data.data;
                }
            });
        },
        appoint(data) {
            window.open(data.url, 'blank');
        },
        getSpecialFood() {
            this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '49',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.specialFoodList = res.data.data;
                    console.log('specialFood', this.specialFoodList);
                }
            });
        }
    }
};
